module.exports = __webpack_public_path__ + "static/media/ViviendasAlcaldesa.44ad7e0f.mp3";